import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AppBar from "../components/AppBar";
import Category from "../components/Category";
import Hotel from "../components/Hotel";
import { db } from "../firebase";

const useStyles = makeStyles((theme) => ({
  title: {
    padding: 20,
  },
  root: {
    maxWidth: 400,
  },
  media: {
    height: 250,
  },
}));

function Explore() {
  const [categories, setCategories] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const classes = useStyles();
  function populateCategories() {
    setCategories([]);
    db.collection("categories")
      .get()
      .then((data) => {
        console.log("GET CAT");
        for (const category of data.docs) {
          setCategories((initCategories) => [
            ...initCategories,
            { title: category.id, data: category.data() },
          ]);
        }
      });
  }

  function populateHotels() {
    setHotels([]);
    db.collection("restaurants")
      .get()
      .then((data) => {
        console.log("GET");
        for (const hotelData of data.docs) {
          const hotel = hotelData.data();
          setHotels((initHotels) => [
            ...initHotels,
            {
              displayName: hotel.displayName,
              location: hotel.location,
              media: hotel.media,
              rating: hotel.rating,
            },
          ]);
        }
      });
  }

  useEffect(() => {
    setLoading(true);
    populateCategories();
    populateHotels();
    setLoading(false);
  }, []);

  function ExploreCard({ obj }) {
    return (
      <Grid item xs={6}>
        <Card className={classes.root}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image={obj.image}
              title={obj.title}
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                {obj.title}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                {obj.description}
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              Share
            </Button>
            <Button
              size="small"
              color="secondary"
              onClick={() => {
                history.push("/");
              }}
            >
              {obj.actionText}
            </Button>
          </CardActions>
        </Card>
      </Grid>
    );
  }

  const objects = [
    {
      title: "Healthy",
      image:
        "https://images.unsplash.com/photo-1540420773420-3366772f4999?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=631&q=80",
      actionText: "Learn more",
      description: "We also provide healthy food for covid patients",
      to: "/",
    },
    {
      title: "Charity",
      image:
        "https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
      actionText: "Donate",
      description: "Your small effort can make a big change.",
      to: "/donations",
    },
  ];

  return (
    <div>
      <AppBar />
      <Container>
        <Grid container spacing={2}>
          {objects.map((obj) => {
            return <ExploreCard obj={obj} />;
          })}
        </Grid>
        <Typography className={classes.title} variant="h5">
          Browse by category
        </Typography>
        <Grid container align="center" spacing={4}>
          {categories.map((category) => {
            return <Category category={category} />;
          })}
        </Grid>
        <Typography className={classes.title} variant="h5">
          Hotels near you
        </Typography>
        <Grid container spacing={4}>
          {hotels.map((hotel) => {
            return <Hotel hotelData={hotel} />;
          })}
        </Grid>
      </Container>
    </div>
  );
}

export default Explore;
